export const m = {
  /**********************通用Start************************ */
  add: "新增",
  delete: "删除",
  handle: "操作",
  deleted: "已删除",
  /**********************通用End************************ */

  amazonOrder: '亚马逊订单',
  manualOrder: '手动订单',
  orderSource: "订单来源",
  buyNotes: "买家留言",
  inputSku: "输入SKU",
  qty: "数量",
  unitPrice: "单价",
  total: "总价",
  postage: "运费",
  itemTotal: "Item总价",
  skuName: "产品名",
  img: "图片",

  isDefaultAddress: "默认地址",
  isNotDefaultAddress: "手动输入地址",
  customerName: "客户名称",
  customerPhone: "客户电话",
  street1: "街道地址1",
  street2: "街道地址2",
  suburb: "区",
  state: "州",
  email: "Email",
  zip: "邮编",
  countryCode: "国家代码",

  sumitForm: "提交",
  cancelForm: "取消",

  deliveryType: "发货方式",

  addressSelect: "从已有地址里选择",
  addressAdd: "手动收入地址",
  addressAlarm: "请选择地址",
  systemEmail: '系统邮箱',
  orderFrom: "请选择订单来源",
  orderDate: "订单日期",
  purchaseOrderDate: "采购订单日期",
  btnAddInvoice: "增加Invoice地址",
  //商品------------------------------------------------------
  spu_nowCategory: "当前分类",
  spu_selectedCategroy: "已选分类",
  spu_fillProductInfo: "填写商品信息",
  spu_fillProductAttribute: "填写商品属性",
  spu_productCategory: "商品分类",
  spu_fromUrl: "来源url",
  spu_shorName: "报关中文名",
  spu_supplier: "商品供应商",
  spu_currency: "货币单位",
  spu_isPower: "是否是240V电源",
  spu_isSafe: "是否有安全隐患",
  spu_isSAAo: "是否认证了SAAO",
  spu_notSpecial: "此产品非特别推荐产品",
  spu_isSpecial: "此产品为特别推荐产品",
  spu_makeTime: "制作时间",
  spu_recommendations: "备注/推荐理由",
  spu_vedioCode: "视频代码",
  spu_introduction: "商品英文介绍",
  spu_descCn: "商品中文介绍",
  spu_pacakgeNum: "Package(包装数量)",
  spu_allowEbay: "是否允许上架到Ebay",
  spu_allowAmazon: "是否允许上架到Amazon",
  spu_allowShipping: "是否允许上架到Shipping",
  spu_type: "商品类型：",
  spu_attributeTypes: "属性类型",
  spu_specification: "商品规格",
  spu_album: "商品相册",
  spu_uploadManual: "上传说明书",
  spu_detailHtml: "编辑商品详细描述",
  spu_copyHtml: "复制完整html",
  spu_previousStep: "上一步，填写商品信息",
  spu_nextStep: "下一步，填写商品属性",
  spu_submit: "完成，提交商品",

  sku_code: "SKU编码",
  sku_pic: "SKU 主图",
  sku_unitPrice: "采购价格",
  sku_length: "长mm",
  sku_width: "宽mm",
  sku_height: "高mm",
  sku_weight: "重量g",
  sku_sales_price: "售价",
  sku_sp1: "属性1",
  sku_sp2: "属性2",
  sku_sp3: "属性3",
  sku_name: "SKU名称",
  sku_handle: "操作",
  sku_delete: "删除SKU",
  sku_discontinue: "下架SKU",
  sku_recover: "恢复SKU",
  sku_refresh: "刷新列表",
  add_notes_alrt:"是否确定提交产品备注？",

  //Dropshipping------------------------------------------------------

  selectPurchaseType: "选择采购类型",
  overtimeType: "超时类型",
  orderChinaExpressOverTime: "订单-中国单号超时",
  chinaExpressSeaOverTime: "中国单号-海运超时",
  seaMilperraOverTime: "海运-Milperra超时",
  MilperraDeliveryOverTime: "Milperra-发货超时",
  dropshippingNote1: " 已删除标识代表采购需求被删除",
  dropshippingNote2: "若确认某进程无需追踪，则点击Edit Notes，输入'已买',则可消除该进程",
  chinaTrackingCreateTime: "中国单号生成日期",
  internationTrackingCreatedTime: "国际单号生成时间",
  estimatedArrivalAusTime: "预计抵达澳洲时间",
  MilperraInStockTime: "Milperra入库时间",
  requirementCreationDate: "需求创建日期",
  OpenOrderQty: "采购未收件数量",
  PendingOrderQty: "待发货数量",
}


// WEBPACK FOOTER //
// ./src/common/lang/zh.js